import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './CreateModal.css';

const CreateModal = ({
    isOpen,
    onClose,
    title,
    onSubmit,
    children,
    submitButtonText = 'Create'
}) => {
    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(e);
    };

    return (
        <div className="create-modal-overlay">
            <div className="create-modal-content">
                <div className="create-modal-header">
                    <h2>{title}</h2>
                    <button className="create-modal-close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    {children}
                    <button type="submit" className="create-modal-submit">
                        {submitButtonText}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default CreateModal;
